<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
                <v-card>
                    <v-card-title>{{ t('Confirmación_de_Correo_Electrónico') }}</v-card-title>
                    <v-card-text>
                        <HelperCarregant v-if="loading" :missatge="t('Confirmando_correo_electrónico')" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { axios } from '../axios';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useUiStore }     from '@/stores/ui';
import HelperCarregant from './HelperCarregant.vue';

const uiStore     = useUiStore();
const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const loading = ref(true);
const key = computed(() => route.params.key);

const confirmEmail = async () => {
    try {
        await axios.post(
            `dj-rest-auth/registration/account-confirm-email/${key.value}/`,
            { key: key.value }
        );
        uiStore.triggerSnackbar({ message: t("Correo_electrónico_confirmado_con_éxito"), color: 'success' });
        router.push('/login');
    } catch (error) {
        console.error(error);
        uiStore.triggerSnackbar({
            message: 'Error al confirmar el correo electrónico. Puede que el enlace haya caducado o sea inválido.',
            color: 'success'
        });
        router.push('/login');
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    confirmEmail();
});
</script>